import React from 'react';
import type { EquipmentFace } from '../../../types';
import type { DeviceModel } from '../../../types/deviceModel';
import type { FacedPort } from '../../../engine/networkLogic/layoutPorts';
import { ElectricalModelPanel } from '../../Equipment/ElectricalModelPanel';

interface ElectricalInspectorProps {
  draft: DeviceModel;
  onChange: (next: DeviceModel) => void;
  ports: FacedPort[];
  onPortsChange: (next: FacedPort[]) => void;
  hoverPortId: string | null;
  onHoverPort: (id: string | null, face?: EquipmentFace) => void;
}

const ElectricalInspector: React.FC<ElectricalInspectorProps> = (props) => (
  <div className="w-[420px] shrink-0 min-h-0 overflow-hidden border-l border-white/10 bg-black/20">
    <ElectricalModelPanel
      draft={props.draft}
      onChange={props.onChange}
      ports={props.ports}
      onPortsChange={props.onPortsChange}
      isDark
      hoverPortId={props.hoverPortId}
      onHoverPort={props.onHoverPort}
      compact
    />
  </div>
);

export default ElectricalInspector;
